import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EvenementService } from '../../../_services/evenement/evenement.service';
import { Evenement } from '../../../_interfaces/evenement';
import { AdminPageHeaderComponent } from '../../../_components/admin-page-header/admin-page-header.component';

type StatutFilter = 'tous' | 'passes' | 'a-venir';

@Component({
    selector: 'app-historique-evenements',
    imports: [FormsModule, RouterModule, AdminPageHeaderComponent],
    templateUrl: './historique-evenements.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './historique-evenements.component.scss'
})
export class HistoriqueEvenementsComponent implements OnInit {
  private evenementService = inject(EvenementService);

  evenements: Evenement[] = [];
  loading = true;

  search = '';
  anneeFilter = 'toutes';
  statutFilter: StatutFilter = 'tous';

  pageSize = 15;
  currentPage = 1;

  ngOnInit() {
    this.evenementService.readAllEvenements().subscribe(data => {
      this.evenements = [...data].sort(
        (a, b) => new Date(b.dateDebut).getTime() - new Date(a.dateDebut).getTime()
      );
      this.loading = false;
      this.currentPage = 1;
    });
  }

  get annees(): number[] {
    const years = new Set(this.evenements.map(e => new Date(e.dateDebut).getFullYear()));
    return Array.from(years).sort((a, b) => b - a);
  }

  get filteredEvenements(): Evenement[] {
    const q = this.search.trim().toLowerCase();
    const now = new Date();

    return this.evenements.filter(e => {
      if (q && !(e.nom || '').toLowerCase().includes(q) && !(e.lieu || '').toLowerCase().includes(q)) {
        return false;
      }
      if (this.anneeFilter !== 'toutes' && new Date(e.dateDebut).getFullYear() !== Number(this.anneeFilter)) {
        return false;
      }
      const estPasse = new Date(e.dateDebut) < now;
      if (this.statutFilter === 'passes' && !estPasse) return false;
      if (this.statutFilter === 'a-venir' && estPasse) return false;
      return true;
    });
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filteredEvenements.length / this.pageSize));
  }

  get paginatedEvenements(): Evenement[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredEvenements.slice(start, start + this.pageSize);
  }

  get rangeStart(): number {
    return this.filteredEvenements.length === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.filteredEvenements.length);
  }

  onFilterChange() {
    this.currentPage = 1;
  }

  goToPage(page: number) {
    this.currentPage = Math.min(Math.max(1, page), this.totalPages);
  }

  previousPage() {
    this.goToPage(this.currentPage - 1);
  }

  nextPage() {
    this.goToPage(this.currentPage + 1);
  }

  isPasse(evenement: Evenement): boolean {
    return new Date(evenement.dateDebut) < new Date();
  }

  formatDate(value: string | undefined): string {
    if (!value) return '';
    const d = new Date(value);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  formatTime(value: string | undefined): string {
    if (!value) return '';
    const d = new Date(value);
    return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  }
}
